
import VueAxios from "vue-axios";
import axios from "axios";
//Vue.use(VueAxios, axios);
//Vue.use(Vuex)
//const this.$store.state.baseapi = "http://127.0.0.1:8000/api/";
export default {
    data() {
      return {
       
      }
    },
  
    created() {
     
    },
  
    methods: {
     
     GET_ADMINISTRADORES: async function(data) {




      
      var result =  await axios
        ({
          method: 'GET',
          url: this.$store.state.baseapi+"sistema_municipios/"+data.idmunicipio+"/indicador_administradores/" ,
          responseType: 'json', 
          headers: {
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          },
            
          }
          
        )
        .then(
          response => {
         
            //context.commit('SET_USER_DEALS', { deals: response.data.data })
            return response.data;
          },
          err => {
            
            return null;
          }
        );
        return result;





    },
    GET_ADMINISTRADORESHOW: async function(data) {




      
      var result =  await axios
        ({
          method: 'GET',
          url: this.$store.state.baseapi+"indicador_administradores/"+data.id ,
          responseType: 'json',
          headers: {
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          },
            
          }
          
        )
        .then(
          response => {
         
            //context.commit('SET_USER_DEALS', { deals: response.data.data })
            return response.data;
          },
          err => {
            
            return null;
          }
        );
        return result;





    },


    GET_ADMINISTRADORESIMPRIMIR: async function(data) {




      
      var result =  await axios
        ({
          method: 'GET',
          url: this.$store.state.baseapi+"sistema_municipios/"+data.idmunicipio+"/indicador_administradores/"+data.id+ "/indicador_administradoresimprimir/",
          responseType: 'json', 
          headers: {
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          },
            
          }
          
        )
        .then(
          response => {
         
            //context.commit('SET_USER_DEALS', { deals: response.data.data })
            return response.data;
          },
          err => {
            
            return null;
          }
        );
        return result;





    },







    CREAR_ADMINISTRADORES: async function(data) {



      
      var result =  await axios
        ({
          method: 'POST',
          url: this.$store.state.baseapi+"indicador_administradores/" ,
          responseType: 'json',
          headers: {
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          },
          data:{
          //QUITAR COMILLAS SOLO EN DATA 
          
           idmunicipio:data.idmunicipio,
           idclasificacion:data.idclasificacion,
           clave:data.clave,
           nombre:data.nombre, 
           objetivo_indicador:data.objetivo_indicador, 
           interpretacion:data.interpretacion,
           //idvariables:data.idvariables,
           variables_agregadas:data.variables_agregadas, 
           formula:data.formula, 
           unidad_medida_resultado:data.unidad_medida_resultado,
           idfrecuencia:data.idfrecuencia,
           idsecretaria:data.idsecretaria, 
           iddepartamento:data.iddepartamento, 
           valor_min:data.valor_min,
           valor_max:data.valor_max,
           meta:data.meta, 
           motivo:data.motivo,
           aceptado:data.aceptado,
           type:data.type,
   tipo:data.tipo,
         
   dimension:data.dimension,
   nivel:data.nivel,
   tendencia:data.tendencia,
   tipo_meta:data.tipo_meta,
   movimiento:data.movimiento,
   persona_responsable:data.persona_responsable,
   claridad:data.claridad,
   relevancia:data.relevancia,
   economica:data.economica,
   monitoreable:data.monitoreable,
   adecuado:data.adecuado,
   aportacion_marginal:data.aportacion_marginal,
     
   semaforo_verde:data.semaforo_verde,
   semaforo_amarillo:data.semaforo_amarillo,
   semaforo_rojo:data.semaforo_rojo,
          }
            
          }
          
        )
        .then(
          response => {
         
            //context.commit('SET_USER_DEALS', { deals: response.data.data })
            return response.data;
          },
          err => {
            
            return null;
          }
        );
        return result;





    },





    EDITAR_ADMINISTRADORES: async function(data) {




      
      var result =  await axios
        ({
          method: 'PUT',
          url: this.$store.state.baseapi+"indicador_administradores/"+data.id ,
          responseType: 'json',
          headers: {
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          },
          data:{
            
           idmunicipio:data.idmunicipio,
           idclasificacion:data.idclasificacion,
           'clave':data.clave,
           'nombre':data.nombre, 
           'objetivo_indicador':data.objetivo_indicador, 
           'interpretacion':data.interpretacion,
           //idvariables:data.idvariables,
           'variables_agregadas':data.variables_agregadas, 
           'formula':data.formula, 
           'unidad_medida_resultado':data.unidad_medida_resultado,
           idfrecuencia:data.idfrecuencia,
           idsecretaria:data.idsecretaria, 
           iddepartamento:data.iddepartamento, 
           'valor_min':data.valor_min,
           'valor_max':data.valor_max,
           'meta':data.meta, 
           'motivo':data.motivo,
           'aceptado':data.aceptado,
           type:data.type,
           'tipo':data.tipo,
           
           'dimension':data.dimension,
           'nivel':data.nivel,
           'tendencia':data.tendencia,
           'tipo_meta':data.tipo_meta,
           'movimiento':data.movimiento,
           'persona_responsable':data.persona_responsable,
           'claridad':data.claridad,
           'relevancia':data.relevancia,
           'economica':data.economica,
           'monitoreable':data.monitoreable,
           'adecuado':data.adecuado,
           'aportacion_marginal':data.aportacion_marginal,

                
   'semaforo_verde':data.semaforo_verde,
   'semaforo_amarillo':data.semaforo_amarillo,
   'semaforo_rojo':data.semaforo_rojo,
          }
            
          }
          
        )
        .then(
          response => {
         
            //context.commit('SET_USER_DEALS', { deals: response.data.data })
            return response.data;
          },
          err => {
            
            return null;
          }
        );
        return result;





    },

    ELIMINAR_ADMINISTRADORES: async function(data) {




      
      var result =  await axios
        ({
          method: 'delete',
          url: this.$store.state.baseapi+"indicador_administradores/"+data.id ,
          responseType: 'json',
          headers: {
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          }
            
          }
          
        )
        .then(
          response => {
         
            //context.commit('SET_USER_DEALS', { deals: response.data.data })
            return response.data;
          },
          err => {
            
            return null;
          }
        );
        return result;





    },
    },
  }